// extracted by mini-css-extract-plugin
export default {"header":"App_header__n5g8T"};